import { render, staticRenderFns } from "./OutagesListTown.vue?vue&type=template&id=2f7a2de6&scoped=true"
import script from "./OutagesListTown.vue?vue&type=script&lang=js"
export * from "./OutagesListTown.vue?vue&type=script&lang=js"
import style0 from "./OutagesListTown.vue?vue&type=style&index=0&id=2f7a2de6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7a2de6",
  null
  
)

export default component.exports